<div  *ngIf="section">
    <div class="slide ">
 <div class="">
        <!-- Cabecera: píldora de posición + botón Ver resultados 
        <div class="flex items-center justify-between gap-3 mb-3">

            Píldora: Sección X · Y lecciones
            <div class=" inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold"
                style="display:none;  background: color-mix(in srgb, var(--v2-color-secondary-500), white 92%); color: var(--v2-color-secondary-500);">
                <span class="w-1.5 h-1.5 rounded-full" style="background: var(--v2-color-secondary-500);"></span>
                {{ 'player.section.name' | translate }} {{ section?.position }}
                <ng-container *ngIf="section?.sectionContents?.length">
                    &nbsp;·&nbsp; {{ section?.sectionContents?.length }} {{ 'player.section.lessons' | translate }}
                </ng-container>
            </div> 

        </div>-->

        

        <!-- Título y descripción -->
        <msc-heading-actions [showMenu]="true">
            <h2 class="text-xl font-bold text-gray-700 tracking-tight">{{ section.title }}</h2>
        </msc-heading-actions>

        <p *ngIf="section.description"
            class="text-sm text-[#5F6877] mt-1 mb-5 rich-text"
            [innerHTML]="section?.description | safe:'html'">
        </p>
        
        <!-- Media de la sección -->
        <div class="flex justify-center mb-6" *ngIf="section?.media">
            <media-holder [media]="section?.media"></media-holder>
        </div>
        
          <!-- Lo que verás en este módulo/unidad: replica el submenu del sidebar -->
        <div *ngIf="section?.sectionContents?.length" class="mb-6">
            <div class="flex items-center gap-2 text-base text-gray-700 mb-3" style="font-weight: 400;">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    class="stroke-gray-700" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round">
                    <line x1="8" y1="6" x2="21" y2="6"></line>
                    <line x1="8" y1="12" x2="21" y2="12"></line>
                    <line x1="8" y1="18" x2="21" y2="18"></line>
                    <line x1="3" y1="6" x2="3.01" y2="6"></line>
                    <line x1="3" y1="12" x2="3.01" y2="12"></line>
                    <line x1="3" y1="18" x2="3.01" y2="18"></line>
                </svg>
                {{ 'player.section.presentation.content-list' | translate }}
            </div>

            <div class="rounded-2xl border border-[#E8EAEF] divide-y divide-[#E8EAEF] overflow-hidden">
                <a *ngFor="let sectionContent of section?.sectionContents; let i = index"
                    [routerLink]="navigateContent(sectionContent)" queryParamsHandling="merge"
                    class="flex items-center gap-3 px-4 py-3 no-underline cursor-pointer transition-colors hover:bg-[#F6F7F9]">

                    <!-- Número de orden -->
                    <span class="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full text-[11px] font-semibold"
                        style="background: color-mix(in srgb, var(--v2-color-secondary-500), white 88%); color: var(--v2-color-secondary-500);">
                        {{ i + 1 }}
                    </span>

                    <!-- Icono según el tipo de contenido (mismo criterio que el sidebar) -->
                    <span class="w-4 h-4 flex-shrink-0 flex items-center justify-center text-[#6B7280]"
                        [ngSwitch]="getContentIconKey(sectionContent)">
                        <!-- VIDEO -->
                        <svg *ngSwitchCase="'video'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                            <circle cx="12" cy="12" r="10"></circle>
                            <polygon points="10 8 16 12 10 16 10 8"></polygon>
                        </svg>
                        <!-- AUDIO -->
                        <svg *ngSwitchCase="'audio'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                            <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
                            <path
                                d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z">
                            </path>
                        </svg>
                        <!-- PDF -->
                        <svg *ngSwitchCase="'pdf'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                            <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                            <path d="M10 9H8"></path>
                            <path d="M16 13H8"></path>
                            <path d="M16 17H8"></path>
                        </svg>
                        <!-- DOCUMENT / CHEATSHEET -->
                        <svg *ngSwitchCase="'document'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                            <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                            <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                            <path d="M16 13H8"></path>
                            <path d="M16 17H8"></path>
                            <path d="M10 9H8"></path>
                        </svg>
                        <!-- GENERIC MEDIA -->
                        <i *ngSwitchCase="'media'" class="icon-sub icon icon-media"
                            style="color: currentColor !important;"></i>
                        <!-- IMAGE -->
                        <svg *ngSwitchCase="'image'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                            <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
                            <circle cx="9" cy="9" r="2"></circle>
                            <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"></path>
                        </svg>
                        <!-- DISCUSSION -->
                        <svg *ngSwitchCase="'discussion'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                        </svg>
                        <!-- EXCHANGE -->
                        <svg *ngSwitchCase="'exchange'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                            <path d="M17 1l4 4-4 4"></path>
                            <path d="M3 11V9a4 4 0 0 1 4-4h14"></path>
                            <path d="M7 23l-4-4 4-4"></path>
                            <path d="M21 13v2a4 4 0 0 1-4 4H3"></path>
                        </svg>
                        <!-- EVENT -->
                        <svg *ngSwitchCase="'event'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                            <rect width="18" height="18" x="3" y="4" rx="2" ry="2"></rect>
                            <line x1="16" x2="16" y1="2" y2="6"></line>
                            <line x1="8" x2="8" y1="2" y2="6"></line>
                            <line x1="3" x2="21" y1="10" y2="10"></line>
                        </svg>
                        <!-- PROJECT / SELF-ASSESSMENT -->
                        <svg *ngSwitchCase="'project'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                            <rect width="8" height="4" x="8" y="2" rx="1" ry="1"></rect>
                            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                            <path d="m9 14 2 2 4-4"></path>
                        </svg>
                        <!-- SCORM -->
                        <svg *ngSwitchCase="'scorm'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                            <path
                                d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z">
                            </path>
                            <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                            <line x1="12" x2="12" y1="22.08" y2="12"></line>
                        </svg>
                        <!-- EXTERNAL LINK -->
                        <i *ngSwitchCase="'link'" class="icon-sub icon icon-link-outline"
                            style="color: currentColor !important;"></i>
                        <!-- CERTIFICATE -->
                        <svg *ngSwitchCase="'certificate'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                            <circle cx="12" cy="8" r="6"></circle>
                            <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"></path>
                        </svg>
                        <!-- EXERCISE / QUIZ -->
                        <svg *ngSwitchCase="'exercise'" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                            <path d="M9 11l3 3l8 -8"></path>
                            <path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9"></path>
                        </svg>
                        <!-- DEFAULT -->
                        <svg *ngSwitchDefault xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                            <circle cx="12" cy="12" r="10"></circle>
                        </svg>
                    </span>

                    <!-- Título del contenido -->
                    <span class="flex-1 text-sm text-gray-700 line-clamp-2 min-w-0">
                        {{ sectionContent.title || (sectionContent?.context === 'exercise' && sectionContent?.exercise?.title) ||
                        ('player.sidebar.section-content.context-' + sectionContent?.context | translate) }}
                    </span>

                    <!-- Flecha -->
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="w-4 h-4 flex-shrink-0">
                        <path d="m9 18 6-6-6-6"></path>
                    </svg>
                </a>
            </div>
        </div>
       

        <!-- Botones de inicio (toda la lógica original intacta) -->
        <div *ngIf="section?.sectionContents[0]" class="flex justify-end mt-4">
            <a class="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold text-white transition-all duration-200 hover:scale-[1.02] hover:shadow-lg hover:text-white active:scale-[0.98]"
                style="background: var(--v2-color-primary-500);"
                *ngIf="section?.sectionContents[0]?.context === 'media'"
                [routerLink]="[section?.sectionContents[0]?.context, section?.sectionContents[0][section?.sectionContents[0]?.context].id, 'content', section?.sectionContents[0]?.id]"
                queryParamsHandling="merge">
                {{ 'player.section.presentation.begin' | translate }}
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path>
                </svg>
            </a>
            <a class="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold text-white transition-all duration-200 hover:scale-[1.02] hover:shadow-lg hover:text-white active:scale-[0.98]"
                style="background: var(--v2-color-primary-500);"
                *ngIf="section?.sectionContents[0]?.context !== 'exercise' && section?.sectionContents[0]?.context !== 'media'"
                [routerLink]="navigate(section)"
                queryParamsHandling="merge">
                {{ 'player.section.presentation.begin' | translate }}
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path>
                </svg>
            </a>
        </div>

        <div *ngIf="section.sectionContents[0]" class="flex justify-end mt-4">
            <a class="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold text-white transition-all duration-200 hover:scale-[1.02] hover:shadow-lg hover:text-white active:scale-[0.98]"
                style="background: var(--v2-color-primary-500);"
                *ngIf="section?.sectionContents[0]?.context === 'exercise'"
                [routerLink]="['exercise', section?.sectionContents[0]?.exercise?.id, 'question', section?.sectionContents[0]?.exercise?.questions[0]?.id]"
                queryParamsHandling="merge">
                {{ 'player.section.presentation.begin' | translate }}
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path>
                </svg>
            </a>
        </div>

        <msc-next-prev-btn *ngIf="!section.sectionContents[0]"></msc-next-prev-btn>
</div>
    </div>
</div>

<!-- Footer (Debate / Notas) ocultado: las vistas de "Module header" del sidebar no deben mostrar app-footer -->
<!-- <app-footer [context]="'section'" [contextId]="section?.id"></app-footer> -->
